import router from "../../router";
import axios from "axios";
import store from "../index";
import moment, { relativeTimeRounding } from "moment";
import i18 from "../../i18n";

export default {
  namespaced: true,
  state: {
    //calculo: {},
      data : {
        brand: 3, // marca del arrendatario
        idioma: i18.locale,
        fecha_retiro: "",
        hora_retiro: "",
        fecha_devolucion: "",
        hora_devolucion: "",
        sucursal_retiro: 5,
        sucursal_devolucion: 5,
        edad: "25", // edad del arrendatario
        vehiculo_id: 0,
        conductor_adicional:0,
        coberturas: [],
        accesorios:[],
        coberturas_obligadorias:[],
        forma_pago: 7
      }, // datos enviados para realizar la reserva
      sucursales: [], // objetos de sucursales para el primer flujo
      horas: [],
      loader:false,
      procesoReserva: false,
      confirmado:false, // reserva fue confirmada
      reserve:{}, // datos de la reserva confirmada
      precalculo:{}, // objeto para los autos con su precalculo en el segundo flujo
      calculo:[],
      auto:[],
      forma_pago:[],
      addEdd: false, // estado del boton de Exoneración del Deducible, si está en false no ha sido seleccionado
      addCap: false, // estado del boton de Cobertura de Accidentes Personal, si está en false no ha sido seleccionado
      addClp: false,
      addRap: false,
      addMifi: false, // estado del boton de agregar mifi
      addSillabb: false, // estado del boton de agregar silla de bb
      addCondAdic: false, // true: conductores adicionales agregados, de lo contrario false
      accion_modificar: false, // calculo y detalles del auto seleccionado
      getReserve: [], // objeto de reserva encontrada para modificar, cancelar o ver detalles.
      viewDetails: false, // mostrar detalles cuando la reserva se haya encontrado
      reservaPreCalculada:[], // objeto de la reserva recalculada 
      vehiculo_id: 0, // id del auto seleccionado desde la sección de flota
      motivosCancelar: [], // motivos por el cual cancelar la reserva
      errors: {}, // para mostrar mensajes de error
      rutaurl: ''      
  },
  mutations: {
    MT_MIRUTA(state, rutaurl)
    {
       console.log("prueba desde mt " + rutaurl)
       state.rutaurl = rutaurl
    },
    MT_VALORESPORDEFECTO(state)
    {
      //console.clear()
      ///state.calculo= {}
      state.data = {
        brand: 3, // marca del arrendatario
        idioma: i18.locale,
        fecha_retiro: "",
        hora_retiro: "",
        fecha_devolucion: "",
        hora_devolucion: "",
        sucursal_retiro: 5,
        sucursal_devolucion: 5,
        edad: "25", // edad del arrendatario
        vehiculo_id: 0,
        conductor_adicional:0,
        coberturas: [],
        accesorios:[],
        coberturas_obligadorias:[],
        forma_pago: 7
      }, // datos enviados para realizar la reserva
      state.sucursales= [] // objetos de sucursales para el primer flujo
      state.horas= []
      state.loader=false
      state.procesoReserva= false
      state.confirmado=false // reserva fue confirmada
      state.reserve={} // datos de la reserva confirmada
      state.precalculo={} // objeto para los autos con su precalculo en el segundo flujo
      state.calculo=[]
      state.auto=[]
      state.forma_pago=[]
      state.addEdd= false // estado del boton de Exoneración del Deducible, si está en false no ha sido seleccionado
      state.addCap= false // estado del boton de Cobertura de Accidentes Personal, si está en false no ha sido seleccionado
      state.addClp= false
      state.addRap= false
      state.addMifi= false // estado del boton de agregar mifi
      state.addSillabb= false // estado del boton de agregar silla de bb
      state.addCondAdic= false // true= conductores adicionales agregados, de lo contrario false
      state.accion_modificar= false // calculo y detalles del auto seleccionado
      state.getReserve = [] // objeto de reserva encontrada para modificar, cancelar o ver detalles.
      state.viewDetails = false // mostrar detalles cuando la reserva se haya encontrado
      state.reservaPreCalculada = [] // objeto de la reserva recalculada
      state.errors = {} // para mostrar mensajes de error
      state.rutaurl = ''
    },
    MT_PRIMERPASO(state, data) {
      state.sucursales = data;
      this.commit("reservav2/MT_HORARIOXDEFECTO", state.sucursales);
    },
    MT_HORARIOXDEFECTO(state, sucursales) {
      sucursales.forEach((e) => {
        if (e.id == 5) {
          this.commit(
            "reservav2/MT_HORARIO",
            e.horario_sem,
            e.horario_sabado,
            e.horario_domingo
          );
        }
      });
    },
    MT_HORARIO(state, hSemana, hSabado, hDomingo) {
      let separar;
      let dia = moment().format("dddd");
      let horas2 = [];

      if (dia == "Saturday" || dia == "Sábado") {
        separar = hSabado.split("-");
      } else if (dia == "Sunday") {
        separar = hDomingo.split("-");
      } else {
        separar = hSemana.split("-");
      }

      if (separar == "CERRADO") {
        horas2.push("CERRADO");
        this.horas = horas2;
        this.data.hora_retiro = "CERRADO";
        this.data.hora_devolucion = "CERRADO";
      } else {
        let open = separar[0];
        let close = separar[1];
        
        let horas = [
          //"00:00",
          //"00:30",
          //"01:00",
          //"01:30",
          //"02:00",
          //"02:30",
          "03:00",
          "03:30",
          "04:00",
          "04:30",
          "05:00",
          "05:30",
          "06:00",
          "06:30",
          "07:00",
          "07:30",
          "08:00",
          "08:30",
          "09:00",
          "09:30",
          "10:00",
          "10:30",
          "11:00",
          "11:30",
          "12:00",
          "12:30",
          "13:00",
          "13:30",
          "14:00",
          "14:30",
          "15:00",
          "15:30",
          "16:00",
          "16:30",
          "17:00",
          "17:30",
          "18:00",
          "18:30",
          "19:00",
          "19:30",
          "20:00",
          "20:30",
          "21:00",
          "21:30",
          "22:00",
          "22:30",
          "23:00",
          "23:30",
        ];

        if (open > close) {
          
          for (let index = 0; index < horas.length; index++) {

            const element = horas[index];
                horas2.push(element)  
          } 

        } else {
          for (let index = 0; index < horas.length; index++) {

            const element = horas[index];
            if ((open <= element && close >= element) || open == "00:01") {
              horas2.push(element);
            }
          }
        }

        if (close === "21:45") {
          horas2.push("22:00");
        }
        state.horas = horas2;
        state.data.hora_retiro = "10:00";
        state.data.hora_devolucion = "10:00";
      }
    },
    MT_PRECALCULO(state, data)
    {
        state.precalculo = data.tarifas;
    },
    MT_CALCULO(state, calculo)
    {
      state.calculo = calculo

      // state.cdw_monto = state.calculo.detalle.cob_obligatoria.monto[0]; // Cobertura colisión y robo
      // state.dat_monto = state.calculo.detalle.cob_obligatoria.monto[1]; // Cobertura daños a terceros

      
    },
    MT_SELECCIONAUTO(state, data)
    {
        state.auto = data.auto
        state.forma_pago = data.forma_pago
    },
    MT_AGREGARCONDUCTOR(state)
    {
        if (state.data.conductor_adicional < 5) {
            state.data.conductor_adicional++; // incremento de conductores
            state.addCondAdic = true;
        }
    },
    MT_QUITARCONDUCTOR(state)
    {
        if (state.data.conductor_adicional >= 1) {
            state.data.conductor_adicional--; // incremento de conductores
            state.addCondAdic = true;

            if (state.data.conductor_adicional === 0) 
            {
                state.addCondAdic = false;
            }
        }
    },  
    MT_ADDITEM(state, item)
    {
      if (item == 'EDD') {
        state.addEdd = !state.addEdd
      } else if(item == 'CAP'){
        state.addCap = !state.addCap
      } else if(item == 'CLP'){
        state.addClp = !state.addClp
      } else if(item == 'RAP'){
        state.addRap = !state.addRap
      } else if(item == 'MW'){
        state.addMifi = !state.addMifi
      } else if(item == 'SB'){
        state.addSillabb = !state.addSillabb
      }
    },
    MT_DATARESERVE(state, data)
    {
      state.reserve = data
    },
    MT_RESERVA(state, reserva)
    {
      if (reserva.error) {
        state.errors = reserva;
      }else{
        
      state.auto = reserva.auto;
      state.getReserve = reserva;
      state.viewDetails = true
      }
    },
    MT_RESERVARECALCULO(state, data)
    {
      state.reservaPreCalculada = data
    },
    MT_RESERVAEDITAR(state, data)
    {
      state.auto = data.reserva.auto;
      state.calculo = data.calculo;
      state.accion_modificar = true

      var str = data.reserva.coberturas;
      var coberturas = str.split(",");

      var str = data.reserva.accesorios_id;
      var accesorios = str.split(",");

      state.data = {
        id: data.reserva.id,
        brand: 3,
        sucursal_retiro: data.reserva.sucursal_retiro,
        sucursal_devolucion: data.reserva.sucursal_devolucion,
        cedula: data.reserva.cedula,
        email:data.reserva.email,
        nombre: data.reserva.nombres,
        apellido_paterno: data.reserva.apellido_paterno,
        licencia: data.reserva.licencia_num,
        pais:data.reserva.pais,
        celular: data.reserva.celular,
        observaciones: data.reserva.observaciones,
        linea_aerea: data.reserva.linea_aerea,
        num_vuelo: data.reserva.vuelo,
        fecha_retiro: moment(data.reserva.fecha_salida).format('YYYY/MM/DD'),
        hora_retiro: moment(data.reserva.fecha_salida).format('h:mm:ss'),
        fecha_devolucion: moment(data.reserva.fecha_entrada).format('YYYY/MM/DD'),
        vehiculo_id: data.reserva.vehiculo_id,
        hora_devolucion: moment(data.reserva.fecha_entrada).format('h:mm:ss'),
        coberturas: [],
        accesorios: [],
        conductor_adicional: data.reserva.conductor_adicional,
        tarifa: data.calculo.detalle.total
      }
      
      
      if (coberturas.includes("EDD")) {
        state.addEdd = true
        state.data.coberturas.push({
          sigla:data.calculo.detalle.coberturas.siglas[0],
          nombre:data.calculo.detalle.coberturas.nombre[0],
          monto:data.calculo.detalle.coberturas.monto[0]
        })
      }
      if (coberturas.includes("CAP")) {
        state.addCap = true
        state.data.coberturas.push({
          sigla:data.calculo.detalle.coberturas.siglas[1],
          nombre:data.calculo.detalle.coberturas.nombre[1],
          monto:data.calculo.detalle.coberturas.monto[1]
        })
      }
      if (coberturas.includes("CLP")) {
        state.addClp = true
        state.data.coberturas.push({
          sigla:data.calculo.detalle.coberturas.siglas[2],
          nombre:data.calculo.detalle.coberturas.nombre[2],
          monto:data.calculo.detalle.coberturas.monto[2]
        })
      }
      if (coberturas.includes("RAP")) {
        state.addRap = true
        state.data.coberturas.push({
          sigla:data.calculo.detalle.coberturas.siglas[3],
          nombre:data.calculo.detalle.coberturas.nombre[3],
          monto:data.calculo.detalle.coberturas.monto[3]
        })
      }

      if(accesorios.includes("MW")){
        state.addMifi = true
        state.data.accesorios.push({
          sigla:data.calculo.detalle.accesorios.siglas[0],
          nombre:data.calculo.detalle.accesorios.nombre[0],
          monto:data.calculo.detalle.accesorios.monto[0]
        })
      }

      if(accesorios.includes("SB")){
        state.addSillabb = true
        state.data.accesorios.push({
          sigla:data.calculo.detalle.accesorios.siglas[1],
          nombre:data.calculo.detalle.accesorios.nombre[1],
          monto:data.calculo.detalle.accesorios.monto[1]
        })
      }

      for (let index = 0; index < data.reserva.conductor_adicional; index++) {
        state.addCondAdic = true
      }
    },
    MT_SELECTFROMFLEET(state, idcar)
    {
      state.vehiculo_id = idcar
    },
    MT_SETMOTIVOSCANCELAR(state, data)
    {
      state.motivosCancelar = data
    }
  },
  actions: {
    primerPaso({ commit, state }) {
      state.loader = true
      axios
        .get("paso-uno/3")
        .then((resp) => {
          state.loader = false
          commit("MT_PRIMERPASO", resp.data);
        })
        .catch(() => {});
    },
    segundoPaso({ commit, state }) {
      // state.data.fecha_retiro = "2025-01-06" 
      // state.data.fecha_devolucion = "2025-01-10" 
      // state.data.hora_retiro = "" 
      // state.data.hora_devolucion = "" 
      // console.log(state.data);
      // return

      state.loader = true
      axios.post("paso-dos", state.data).then((resp) => {
        state.procesoReserva = true
        state.loader = false
        commit("MT_PRECALCULO", resp.data);
        router.push({ name: "Reservestep3" });
      });
    },
    tercerPaso({commit, dispatch, state}, id)
    {
        state.loader = true
        state.data.vehiculo_id = id
        state.procesoReserva= true
        axios.post("paso-tres", state.data).then((resp) => {
          commit("MT_SELECCIONAUTO", resp.data);
          commit('MT_CALCULO', resp.data.calculo)
          /** rap por defecto */
          // agregamos por defecto rap

          let current_page = state.rutaurl
          if (current_page == '/promocion-especial') { //La gerencia señala que para promocion especial no debe haber ninguna cobertura seleccionada previamente
             var rap = {
               sigla: '',
               nombre: '',
               monto: 0,
             };
          } else {
             var rap = {
               sigla: resp.data.calculo.detalle.coberturas.siglas[3],
               nombre: resp.data.calculo.detalle.coberturas.nombre[3],
               monto: resp.data.calculo.detalle.coberturas.monto[3],
             };
          }          

          //colocar aquí la validación de url
          dispatch("addItem", rap);
          /** rap por defecto */
          router.push({ name: "Reservestep4" });
          state.loader = false
        });
    },
    addItem({commit, state}, item)
    {
      //console.log('extras',item)
      state.loader = true
      if (item.sigla == 'EDD' || item.sigla == 'CLP' || item.sigla == 'RAP' || item.sigla == 'CAP') {
        state.data.coberturas.push(item)
      } else {
        state.data.accesorios.push(item)
      }
      
      axios.post('add-items', state.data).then(resp=>{
        state.loader = false
        commit('MT_ADDITEM', item.sigla)
        commit('MT_CALCULO', resp.data.calculo)
      })
    },
    removeItem({commit, state},item)
    {
      if (item.sigla == 'EDD' || item.sigla == 'CLP' || item.sigla == 'RAP' || item.sigla == 'CAP'){
        let posicion = state.data.coberturas.find((cobertura) => cobertura.nombre === item.nombre);
        let indice = state.data.coberturas.indexOf(posicion);
        state.data.coberturas.splice(indice, 1);
      } else {
        let posicion = state.data.accesorios.find((accesorio) => accesorio.nombre === item.nombre);
        let indice = state.data.accesorios.indexOf(posicion); // obtenemos el indice
        state.data.accesorios.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
      }
      state.loader = true
      axios.post('add-items', state.data).then(resp=>{
        state.loader = false
        commit('MT_ADDITEM', item.sigla)
        commit('MT_CALCULO', resp.data.calculo)
      })
    },
    addConductor({commit, state})
    {
      commit('MT_AGREGARCONDUCTOR')
      state.loader = true
      axios.post('add-items', state.data).then(resp=>{
        state.loader = false
        commit('MT_CALCULO', resp.data.calculo)
      })
    },
    removeConductor({commit, state})
    {
      commit('MT_QUITARCONDUCTOR')
      state.loader = true
      axios.post('add-items', state.data).then(resp=>{
        state.loader = false
        commit('MT_CALCULO', resp.data.calculo)
      })
    },
    //almacenar reserva
    cuartoPaso({commit, state}, datos)
    {
      state.loader = true
      // si hay coberturas obligatorias
      if (
        datos.coberturas_obligadorias.monto[0] != 0 &&
        datos.coberturas_obligadorias.monto[1] != 0
      ) {
        state.data.coberturas_obligatorias = datos.coberturas_obligadorias.siglas;
      } else {
        state.data.coberturas_obligatorias = "";
      }
      // si hay coberturas obligatorias

      // si es un usuario autenticado
      let path;
      if (datos.isAuth) {
        path = "paso-cuatro-auth";
      } else {
        path = "paso-cuatro";
      }

      state.data.tarifa = state.calculo.detalle.total
      state.data.periodo = state.calculo.detalle.periodo
      state.data.tarifa_codigo = state.calculo.reserva.tarifa_codigo
      state.data.tarifa_ofrecida = { tarifa: state.calculo.detalle.tarifa_ofrecida, hora_extra: state.calculo.detalle.hora_extra }
      
      axios.post(path, state.data).then((resp) => {
        state.loader = false
        state.procesoReserva = false
        state.confirmado = true
        commit('MT_DATARESERVE', resp.data)
        router.push({ name: "reserveFinalStep" })

        })
        .catch((e) => {
          state.loader = false
          alert('Algo salió mal, vuelva a intentarlo por favor')
        });
    },
    /** pasos para modificar */
    buscarReserva({commit, state}, datos)
    {
      state.loader = true
      axios.get("buscar-reserva/" + datos.num_reserva +"/" +datos.apellido_paterno +"/" +datos.brand).then((resp) => {
          commit('MT_RESERVA', resp.data)
          state.loader = false
        })
        .catch((error) => {});
    },
    detallesReserva({commit, state}, datos)
    {
      state.loader = true
      axios.post("modificar-reserva", datos).then((resp) => {
        commit('MT_RESERVARECALCULO', resp.data)
        state.loader = false
        router.push({ name: "details" })
      }).catch(e=>{
          state.loader = false
          alert('Algo salió mal, vuelva a intentarlo por favor')
      })
    },
    cargaReservaEdit({commit, state}, datos)
    {
      state.loader = true
      axios.post("modificar-reserva", datos).then((resp) => {
        state.loader = false
        commit('MT_RESERVAEDITAR', resp.data)
        router.push({ name: "modificarReserva" });
      })
    },
    // actualizar reserva
    actualizarReserva({ commit, state }) {
      
      state.loader = true
      state.data.tarifa = state.calculo.detalle.total
      state.data.periodo = state.calculo.detalle.periodo
      state.data.tarifa_codigo = state.calculo.reserva.tarifa_codigo
      
      return axios.put("actualizar-reserva", state.data).then(resp=>{
        
        if(resp.status == 200){
          state.loader = false
          return "ok"
        }
      }).catch(e=>{
        console.log(e);
      })
    },
    // motivos cancelar reserva
    motivosCancelarReserva({ commit }) {
      axios.get("motivos-anular").then((resp) => {
        commit("MT_SETMOTIVOSCANCELAR", resp.data);
      });
    },
    // cancelar reserva
    async cancelarReserva({ state }, payload) {
      state.loader = true
      const resp = await axios.post("anular-reserva/3", payload);
      state.loader = false
      return resp.data;
    },
  },
};
